<template>
    <div>
        <div class="upload-img">
            <el-upload
                v-loading="imgLoading"
                class="avatar-uploader"
                action="string"
                :show-file-list="false"
                :http-request="uploadImage"
                :on-success="handleAvatarSuccess"
                :on-change="fileChange"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" fit="cover" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="reminder">点击上传</span>
            </el-upload>
        </div>
    </div>
</template>
<script>
import * as upload from '@/api/food'
export default {
    name: 'ImgUpload',
    data() {
        return {    
            imgLoading: false,
            isZoomIn: false,
            imageUrl: '',
            dialogImageUrl: '',
            id: '',
            fileId: ''
        };
    },
    props: {
        echoFileId: {
            type: String
        }
    },
    methods: {
        handleAvatarSuccess(res, file) {
            this.$emit('getImgFile', file)
            this.imageUrl = URL.createObjectURL(file.raw);
            this.imgLoading = false;
        },
        beforeAvatarUpload(file) {
            const isLt10M = ((file.size / 1024 / 1024) <= 10);
            const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg' || 'image/gif'; 
            if (!isJPG) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            if (!isLt10M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return isJPG && isLt10M;
        },  
        uploadImage(param) {
            this.imgLoading = true;
            const formData = new FormData()
            formData.append('file', param.file)
            param.onSuccess();
        },
        fileChange() {},
        imageEcho() {
            if(this.echoFileId) {
                this.imageUrl = this.$store.state.user.imgBaseUrl + '/' + this.echoFileId;
            }
        },
        remove() {
            this.$confirm('是否确认删除图片?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.imageUrl = '';
                URL.revokeObjectURL(this.imageUrl);
                this.id = '';
                this.fileId = '';
                this.$emit('getImgFile', {});
            })
        },
    },
    mounted() {
        this.imageEcho();
    },
    watch: {
        echoFileId: 'imageEcho'
    }
}
</script>

<style lang="scss" scoped>
    .img-board {
        background-color:black;
        width: 120px;
        height: 120px;
        position: relative;
        margin-top: -122px;
        opacity: 0.6;
        display: none;
        border: 1px dashed #178CFA;
        border-radius: 4px;
        div {
            font-size: 24px;
            font-weight: 700;
            color: #FFFFFF;
            :hover {
                cursor: pointer;
                color: #178CFA;
            }
        }
    }
    .upload-img:hover>.img-board{
        display: block;
    }
    .upload-img {
        width: 122px;
    }
    .reminder {
        color: #8A96A1;
        font-size: 12px;
        position: relative;
        top: 16px;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
        background-color: #F3F6F9;
    }
</style>